import { config } from '@services/config';
import { QuoteFormDiffRequestParams, QuoteFormDiffResponse } from '@lio/api-types';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { quoteQueryKey } from './keys';

export const useQuoteFormDiff = ({
  quoteIdSource,
  quoteIdTarget,
  enabled,
}: QuoteFormDiffRequestParams & { enabled?: boolean }) => {
  const client = useClient();
  const result = useQuery<QuoteFormDiffResponse, Error>({
    queryKey: quoteQueryKey.diffForms(quoteIdSource, quoteIdTarget),
    queryFn: async () => {
      const response = await client
        .get(`quote/${quoteIdSource}/diff-forms/${quoteIdTarget}`)
        .json<QuoteFormDiffResponse>();
      return response;
    },
    enabled: Boolean(quoteIdSource) && Boolean(quoteIdTarget) && enabled,
    ...config,
  });
  return { ...result, quoteFormDiff: result.data };
};
